import { useTranslation } from "react-i18next";

import { ActionIcon, Button } from "@mantine/core";

import { SYSTEM_COLORS } from "@/configs/colorScheme";
import { useIsMobile } from "@/hooks/useIsMobile";
import Icon from "@/utils/icons";

export const AppStatus = () => {
  const { t } = useTranslation();
  const { isMobile } = useIsMobile();
  const statusIcon = <Icon.DOT size={12} weight="fill" color={SYSTEM_COLORS.success} />;

  if (isMobile) return <ActionIcon variant="transparent">{statusIcon}</ActionIcon>;

  return (
    <Button
      component="a"
      variant="subtle"
      href="https://waku-robotics.freshstatus.io/"
      target="_blank"
      leftSection={statusIcon}
    >
      {String(t("status")).toUpperCase()}
    </Button>
  );
};

export default AppStatus;
